import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="url(#paint0_linear_11378_10476)"/>
    <g clip-path="url(#clip0_11378_10476)">
    <path d="M15.9734 16.6C16.7734 15.8 17.5734 15.4837 17.5734 14.6C17.5734 13.7164 16.8571 13 15.9734 13C15.2279 13 14.6014 13.51 14.4238 14.2M15.9734 19H15.9814M23.1998 16C23.1998 19.9765 19.9763 23.2 15.9998 23.2C12.0234 23.2 8.7998 19.9765 8.7998 16C8.7998 12.0236 12.0234 8.80005 15.9998 8.80005C19.9763 8.80005 23.1998 12.0236 23.1998 16Z" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_11378_10476" x1="2.11049" y1="6.7935" x2="9.5395" y2="19.7145" gradientUnits="userSpaceOnUse">
    <stop stop-color="#DAFFC1"/>
    <stop offset="1" stop-color="#2ECC36"/>
    </linearGradient>
    <clipPath id="clip0_11378_10476">
    <rect width="19.2" height="19.2" fill="white" transform="translate(6.3999 6.3999)"/>
    </clipPath>
    </defs>
    </svg>
  );
};


export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;

